import React from 'react';
import styled from 'styled-components';
import { ArrowDownSecondary } from './svgs';
import ColorConstants from '../../constants/ColorConstants';

const defaultProps = {
    arrowColor: ColorConstants['regal-blue'],
    height: '9px',
    width: '9px',
};

const DropdownIndicator = ({ arrowColor, height, width }) => (
    <IconWrapper>
        <ArrowDownSecondary
            backgroundColor={arrowColor}
            height={height}
            width={width}
        />
    </IconWrapper>
);

DropdownIndicator.defaultProps = defaultProps;

const IconWrapper = styled.div`
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    margin: 2px 8px 0 4px;
    padding: 0px;
    transition: color 150ms;
    width: 16px; 
    
    &:hover {
        opacity: 0.8;
    }
`;

export default DropdownIndicator;
